import * as React from "react";
import { mboxes } from "../../consts/mboxes";
import { IMenuItem } from "../Navigation/IMenuItem";
import { MyAccountHeaderBarContainer } from "../AuthNav";
import { ExperienceProvider } from "@origin-digital/features";
import { addMyAccountDropDownMenu } from "../Navigation/NavUtils";
import { NavigationWithExperience } from "../Navigation/NavigationWithExperience";
import { UNKNOWN_MENU_INDEX } from "../Navigation";
import navStructureResidential from "../AuthNav/navStructure.residential.json";
import toolbarItemsResidential from "../AuthNav/toolbarItems.residential.json";
import navStructureSME from "../AuthNav/navStructure.sme.json";
import toolbarItemsSME from "../AuthNav/toolbarItems.sme.json";
import navStructureInitial from "../AuthNav/navStructure.initial.json";
import toolbarItemsInitial from "../AuthNav/toolbarItems.initial.json";
import { NoNavigationHeader } from "../Navigation/NoNavigationHeader";

interface INavigationHeaderProps {
  showHeader: Window["oetal"]["pageData"]["showHeader"];
  authenticated: boolean;
  customerCode?: string;
  nav: IMenuItem[];
}

export const NavigationHeader = (props: INavigationHeaderProps) => {
  const { showHeader, authenticated, customerCode, nav } = props;
  if (showHeader) {
    if (showHeader === "scoped") {
      return <NoNavigationHeader />;
    } else if (authenticated && showHeader !== "unauth") {
      return (
        <MyAccountHeaderBarContainer {...getHeaderBarProps(customerCode)} />
      );
    } else {
      return (
        <ExperienceProvider mboxes={[mboxes.myAccountDropDownMenu]}>
          <NavigationWithExperience
            mbox={mboxes.myAccountDropDownMenu}
            updateNavFunction={addMyAccountDropDownMenu}
            menuItems={nav}
            activeTopMenuIndex={UNKNOWN_MENU_INDEX}
            activeDropdownMenuIndex={UNKNOWN_MENU_INDEX}
          />
        </ExperienceProvider>
      );
    }
  }
  return null;
};

const getHeaderBarProps = (customerCode?: string) => {
  switch (customerCode) {
    case "RESI":
      return {
        logoutUrl: "/for-home/my-account/logout.html",
        navStructure: navStructureResidential,
        toolbarItems: toolbarItemsResidential,
        customerCode
      };

    case "SME":
      return {
        logoutUrl: "/for-business/my-account/logout.html",
        navStructure: navStructureSME,
        toolbarItems: toolbarItemsSME,
        customerCode
      };

    default:
      return {
        logoutUrl: "#",
        navStructure: navStructureInitial,
        toolbarItems: toolbarItemsInitial,
        customerCode
      };
  }
};
